import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React__default, { useMemo } from 'react';
import { classNames } from '../../../helpers/classnames.js';

var LinearProgress = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.type, type = _c === void 0 ? 'solo' : _c, _d = _a.cycled, cycled = _d === void 0 ? false : _d, className = _a.className, style = _a.style, props = __rest(_a, ["value", "type", "cycled", "className", "style"]);
    var limitedValue = useMemo(function () { return (value > 100 ? 100 : value); }, [value]);
    var progressBarTransform = useMemo(function () { return "".concat(limitedValue, "%"); }, [limitedValue]);
    return (React__default.createElement("span", __assign({ "data-testid": "LinearProgress" }, props, { style: __assign({}, style), className: classNames('dsb_progress', 'dsb_progress__linear', "dsb_progress__linear-".concat(type), className) }),
        React__default.createElement("span", { style: { width: progressBarTransform }, className: classNames('dsb_progress-bar', cycled && 'dsb_progress-bar__cycled', "dsb_progress-bar__".concat(type)) })));
};

export { LinearProgress };
